/**
 * The paywall's fine print for a store trial (legacy, clock off): what happens after
 * the trial. The Essentials price is the STORE's price string for this user
 * (useSubscriptionPrices().basicMonthly — their currency, e.g. "CA$16.99"), never an
 * amount typed into the app: "$12.99/month" was shown to users who pay in CAD, and
 * would go stale with the next price change. With no store price (web, or RevenueCat
 * not answering yet) the sentence names the plan without an amount.
 */
export function trialFinePrint(basicMonthly: string | null | undefined): string {
  const price = typeof basicMonthly === 'string' && basicMonthly.trim() ? ` at ${basicMonthly.trim()}/month` : '';
  return (
    "Your free 7-day trial includes full Chat+ access. After the trial, you'll move to CC Essentials" +
    `${price}. You can upgrade to Chat+ or Pro anytime. Cancel anytime before the trial ends to avoid ` +
    "being charged. Payment is charged to your App Store or Google Play account. Manage or cancel in your " +
    "device's subscription settings."
  );
}
